export function day(date) {
  return new Date(date).getDate();
}
